import { useRef } from 'react';
import NavItem from '..';

export default function NavItemCustom({
  id,
  classNames,
  title,
  icon,
  expanded,
  isOpen,
  onToggle,
  disableTooltip = false,
}) {
  const anchorRef = useRef(null);

  const toggleMenu = () => {
    onToggle(id);
  };

  return (
    <>
      <NavItem
        classNames={classNames}
        title={title}
        icon={icon}
        ref={anchorRef}
        isActive={isOpen}
        handleClick={toggleMenu}
        expanded={expanded}
        disableTooltip={disableTooltip}
        isNew
        badgeContent="Beta"
      />
    </>
  );
}
